var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeakMonthlyMilkYield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5102 54.4569H15.2307C14.8652 54.4569 14.584 54.1757 14.584 53.8102V47.4271C14.584 47.0615 14.8652 46.7803 15.2307 46.7803H24.5102C24.8757 46.7803 25.1569 47.0615 25.1569 47.4271V53.8102C25.1569 54.1757 24.8757 54.4569 24.5102 54.4569Z",
    fill: "#92D652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7895 54.4569H24.51C24.1445 54.4569 23.8633 54.1757 23.8633 53.8102V40.0597C23.8633 39.6942 24.1445 39.413 24.51 39.413H33.7895C34.155 39.413 34.4643 39.6942 34.4643 40.0597V53.8102C34.4643 54.1757 34.155 54.4569 33.7895 54.4569Z",
    fill: "#00D2B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0969 54.4569H33.7893C33.4238 54.4569 33.1426 54.1757 33.1426 53.8102V32.2144C33.1426 31.877 33.4238 31.5677 33.7893 31.5677H43.0969C43.4624 31.5677 43.7436 31.877 43.7436 32.2144V53.8102C43.7436 54.1757 43.4624 54.4569 43.0969 54.4569Z",
    fill: "#00D2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3762 54.4569H43.0967C42.7312 54.4569 42.4219 54.1757 42.4219 53.8102V23.0474C42.4219 22.71 42.7312 22.4007 43.0967 22.4007H52.3762C52.7417 22.4007 53.0229 22.71 53.0229 23.0474V53.8102C53.0229 54.1757 52.7417 54.4569 52.3762 54.4569Z",
    fill: "#FF4A59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9315 57.4376H10.6467C10.2812 57.4376 10 57.1283 10 56.7627V53.8102C10 53.4446 10.2812 53.1635 10.6467 53.1635H56.9315C57.297 53.1635 57.6063 53.4446 57.6063 53.8102V56.7627C57.6063 57.1283 57.297 57.4376 56.9315 57.4376Z",
    fill: "#E7E7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7424 45.6555H12.5315C12.166 45.6555 11.8848 45.3462 11.8848 44.9807C11.8848 44.6151 12.166 44.3339 12.5315 44.3339H20.0675V36.5448C20.0675 36.1792 20.3769 35.8981 20.7424 35.8981H28.2784V28.1089C28.2784 27.7434 28.5596 27.4341 28.9252 27.4341H36.4893V19.6731C36.4893 19.3075 36.7705 18.9982 37.1361 18.9982H45.347C45.6844 18.9982 45.9937 19.3075 45.9937 19.6731C45.9937 20.0105 45.6844 20.3198 45.347 20.3198H37.7828V28.1089C37.7828 28.4745 37.5016 28.7557 37.1361 28.7557H29.6001V36.5448C29.6001 36.9104 29.2907 37.1916 28.9252 37.1916H21.3892V44.9807C21.3892 45.3462 21.0798 45.6555 20.7424 45.6555Z",
    fill: "#E7E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6354 21.529C48.5229 21.529 48.3823 21.4728 48.2698 21.3884C48.0449 21.2478 47.9605 20.9947 48.0168 20.7417L48.6354 17.3673L46.1609 15.0334C45.964 14.8647 45.9078 14.5835 45.964 14.3585C46.0484 14.1054 46.2733 13.9367 46.5264 13.9086L49.9289 13.4868L51.363 10.3656C51.4755 10.1406 51.7004 10 51.9535 10C52.2347 10 52.4596 10.1406 52.5721 10.3656L54.0062 13.4868L57.4087 13.9086C57.6617 13.9367 57.8867 14.1054 57.9711 14.3585C58.0273 14.5835 57.9711 14.8647 57.7742 15.0334L55.2716 17.3673L55.9183 20.7417C55.9746 20.9947 55.8621 21.2478 55.6653 21.3884C55.4684 21.5571 55.1872 21.5571 54.9623 21.4446L51.9535 19.7856L48.9728 21.4446C48.8603 21.5009 48.7479 21.529 48.6354 21.529Z",
    fill: "#FCC53C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakMonthlyMilkYield);
export default __webpack_public_path__ + "static/media/peakMonthlyMilkYield.2475e85dd107abecb8d59bec0eb917f9.svg";
export { ForwardRef as ReactComponent };